export default "__VITE_ASSET__AsriOfUp__"